<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: whaoo
 * @Date: 2023-12-27 14:34:09
 * @LastEditors: whaoo
 * @LastEditTime: 2024-06-12 14:28:58
-->
<template>
    <div class="login">
        <!-- <img src="../../assets/login/bg_1.png" class="login_bg" alt=""> -->
        <img src="../../assets/login/bg.png" class="login_bg" alt="">
        <img src="../../assets/login/waiter.png" class="waiter" alt="">
        <img src="../../assets/login/logo.png" class="logo" alt="">

        <div class="title">久乐体征遥测管理系统

            <!-- <img src="../../assets/login/tips.png" class="tips_logo" alt=""> -->
        </div>
        <div class="login_box" v-loading="loading">
            <div class="input_box">
                <div class="input flex_box">
                    <img src="../../assets/login/user.png" class="left_icon">
                    <img src="../../assets/login/input_icon.png" class="center_icon">
                    <input type="text" v-model="zone_number" placeholder="账号">
                    <div class="tips" v-show="showUserTips">请输入账号</div>
                </div>
                <div class="input flex_box mb3">
                    <img src="../../assets/login/password.png" class="left_icon">
                    <img src="../../assets/login/input_icon.png" class="center_icon">
                    <input @keyup.enter="login" type="password" v-model="password" placeholder="密码">
                    <div class="tips" v-show="showPasswordTips">请输入密码</div>
                </div>

                <div class="comfirm_btn" @click="login">
                    登录
                </div>
                <div class="forget" @click="forget">忘记账号密码？</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            is_small: false,
            zone_number: "",
            password: "",
            showUserTips: false,
            showPasswordTips: false,
            loading: false
        };
    },


    mounted() {
        if (localStorage.getItem('token')) {
            this.$router.push('/device_list')
        }
        if (document.body.clientWidth / document.body.clientHeight < 1.6) {
            this.is_small = true
        }
    },

    methods: {
        login() {
            if (!this.zone_number && !this.password) {
                this.showUserTips = true
                this.showPasswordTips = true
            }
            if (!this.zone_number) {
                this.showUserTips = true
                return
            } else {
                this.showUserTips = false
            }
            if (!this.password) {
                this.showPasswordTips = true
                return
            } else {
                this.showPasswordTips = false
            }
            this.loading = true
            let data = {
                zone_number: this.zone_number,
                password: this.password
            }
            this.$http({
                url: '/api/zone/login',
                method: "post",
                data: data
            }).then(res => {
                console.log(res);
                this.$message.success("登录成功！")
                localStorage.setItem('token', res.result.token, '7d')
                localStorage.setItem('zone_number', res.result.zone_number, '7d')
                localStorage.setItem('mac', res.result.mac, '7d')
                localStorage.setItem('zone_name', res.result.zone_name, '7d')
                localStorage.setItem('affter', res.result.affter, '7d')
                setTimeout(() => {
                    // this.$router.push('/device_list')
                    this.$router.push('/all_device_data')
                    this.loading = false
                }, 2000);
            }).catch(err => {
                this.loading = false
            })
        },
        forget() {
            this.$alert('<div style="text-align:center;">若您忘记账号密码，可拨打以下电话找回<br/>技术运维电话：400-9616-639</div>', '忘记账号密码', {
                confirmButtonText: '确定',
                dangerouslyUseHTMLString: true
            });
        }
    }
}

</script>
<style scoped>
.login {
    width: 100%;
    height: 100vh;
    position: relative;
    font-size: 0;
    overflow: hidden;
}

.login_bg {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    left: 0;
    top: 0;
}

.waiter {
    width: 28%;
    height: auto;
    position: absolute;
    left: 5%;
    bottom: -3%;
    z-index: 99;
}

.logo {
    width: auto;
    height: 70px;
    position: absolute;
    left: 46px;
    top: 46px;
}

.title {
    font-family: "Source Han Sans CN-BOLD";
    font-size: 48px;
    color: #FFFFFF;
    margin: 244px auto 60px;
    letter-spacing: 4px;
    position: relative;
    z-index: 99;
    text-align: center;
    position: relative;
}

.login_box {
    position: relative;
    width: 816px;
    height: 460px;
    margin: 0 auto;
    /* background-color: rgba(170, 170, 170, 0.712); */
    overflow: hidden;
    border-radius: 20px;
    box-shadow: 0px 4px 36px 0px rgba(37, 43, 80, 0.48), inset 0px 1px 1px 0px rgba(255, 255, 255, 0.5);
}

.input_box {
    position: absolute;
    width: 416px;
    height: 100%;
    left: 200px;
    top: 0;
    z-index: 999;
    padding-top: 80px;
}

.login_box::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(133, 133, 133, 0.1);
    backdrop-filter: blur(20px);
    z-index: 99;
}

.login_overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
}

.flex_box {
    display: flex;
}

.input {
    padding: 22px 26px;
    border-radius: 100px;
    background: rgba(255, 255, 255, 0.3);
    width: 100%;
    margin-bottom: 20px;
    position: relative;
    font-size: 16px;
}

.left_icon {
    width: auto;
    height: 20px;
    margin-right: 20px;
}

.center_icon {
    width: 1px;
    height: 15px;
    margin-right: 20px;
    position: relative;
    top: 2px;
}

input {
    background-color: #FFFFFF00 !important;
    border: none;
    height: 20px;
    line-height: 20px;
    width: calc(100% - 42px);
}

input::placeholder {
    color: #DCEAF9;
}

input:focus {
    outline: none;
}

input:-webkit-autofill,
textarea:-webkit-autofill,
select:-webkit-autofill {
    /* -webkit-text-fill-color: #ededed !important;   */
    -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
    background-color: transparent;
    background-image: none;
    transition: background-color 50000s ease-in-out 0s;
}

.mb3 {
    margin-bottom: 48px;
}

.comfirm_btn {
    width: 100%;
    height: 64px;
    border-radius: 64px;
    background-color: #6377F5;
    color: #FFFFFF;
    text-align: center;
    line-height: 64px;
    font-size: 20px;
    margin-bottom: 12px;
    cursor: pointer;
    font-family: "Source Han Sans CN-BOLD";
}

.tips {
    position: absolute;
    bottom: -20px;
    font-size: 14px;
    color: red;
}

.forget {
    font-size: 16px;
    color: #FFFFFF;
    cursor: pointer;
    text-align: center;
}

.tips_logo {
    width: 140px;
    opacity: .7;
    position: absolute;
    /* right: 0px; */
}

.login_box>>>.el-loading-mask {
    background-color: rgba(209, 209, 209, 0.7) !important;
}
</style>


// WEBPACK FOOTER //
// src/view/layout/login.vue